import React, { useState } from 'react';

interface LoginPageProps {
  onLogin: (success: boolean) => void;
}

const LoginPage: React.FC<LoginPageProps> = ({ onLogin }) => {
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (id === 'pxd' && password === '1105') {
      localStorage.setItem('isAuthenticated', 'true');
      onLogin(true);
    } else {
      setError('아이디 또는 비밀번호가 올바르지 않습니다.');
    }
  };

  return (
    <div className="login-container">
      <style>
        {`
          .login-container {
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 100vh;
            background-color: #f5f5f5;
          }
          
          .login-paper {
            background-color: #fff;
            color: rgba(0, 0, 0, 0.87);
            border-radius: 4px;
            box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12);
            padding: 32px;
            width: 100%;
            max-width: 400px;
            text-align: center;
          }
          
          .login-title {
            margin: 0;
            font-family: "Roboto", "Helvetica", "Arial", sans-serif;
            font-weight: 400;
            font-size: 2.125rem;
            line-height: 1.235;
            letter-spacing: 0.00735em;
            margin-bottom: 24px;
          }
          
          .login-form {
            display: flex;
            flex-direction: column;
            gap: 16px;
          }
          
          .form-field {
            display: flex;
            flex-direction: column;
            position: relative;
          }
          
          .form-input {
            font-family: "Roboto", "Helvetica", "Arial", sans-serif;
            font-weight: 400;
            font-size: 1rem;
            line-height: 1.4375em;
            letter-spacing: 0.00938em;
            color: rgba(0, 0, 0, 0.87);
            box-sizing: border-box;
            width: 100%;
            border: 1px solid rgba(0, 0, 0, 0.23);
            border-radius: 4px;
            padding: 16.5px 14px;
            margin-top: 8px;
          }
          
          .form-input:focus {
            outline: none;
            border-color: #1976d2;
            border-width: 2px;
          }
          
          .form-label {
            color: rgba(0, 0, 0, 0.6);
            font-family: "Roboto", "Helvetica", "Arial", sans-serif;
            font-weight: 400;
            font-size: 1rem;
            line-height: 1.4375em;
            letter-spacing: 0.00938em;
            padding: 0;
            display: block;
          }
          
          .error-message {
            margin: 0;
            font-family: "Roboto", "Helvetica", "Arial", sans-serif;
            font-weight: 400;
            font-size: 1rem;
            line-height: 1.5;
            letter-spacing: 0.00938em;
            color: #d32f2f;
            margin-top: 16px;
          }
          
          .login-button {
            font-family: "Roboto", "Helvetica", "Arial", sans-serif;
            font-weight: 500;
            font-size: 0.875rem;
            line-height: 1.75;
            letter-spacing: 0.02857em;
            text-transform: uppercase;
            min-width: 64px;
            padding: 6px 16px;
            border: 0;
            border-radius: 4px;
            color: #fff;
            background-color: #1976d2;
            box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);
            width: 100%;
            margin-top: 24px;
            margin-bottom: 16px;
            cursor: pointer;
          }
          
          .login-button:hover {
            background-color: #1565c0;
            box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);
          }
          
          .login-button:active {
            box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12);
          }
        `}
      </style>
      
      <div className="login-paper">
        <h1 className="login-title">
          pxd 사무실 인원 배치
        </h1>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-field">
            <label className="form-label">아이디</label>
            <input
              className="form-input"
              value={id}
              onChange={(e) => setId(e.target.value)}
              required
              autoFocus
            />
          </div>
          
          <div className="form-field">
            <label className="form-label">비밀번호</label>
            <input
              className="form-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          
          {error && (
            <p className="error-message">
              {error}
            </p>
          )}
          
          <button
            type="submit"
            className="login-button"
          >
            로그인
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage; 